module.exports = __webpack_public_path__ + "web/img/webm.8d929590.png";